import React, { useEffect, useState } from "react";
import "./Navbar.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assests/sendcheap-logo.png";

const Navbar = ({ clicked, setClicked }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrollToFeatures, setScrollToFeatures] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (scrollToFeatures && location.pathname === "/") {
      setTimeout(() => {
        const el = document.getElementById("services");
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
          setScrollToFeatures(false);
        }
      }, 300);
    }
  }, [location.pathname, scrollToFeatures]);

  const handleFeaturesClick = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
    } else {
      setScrollToFeatures(true);
      navigate("/");
    }
  };

  return (
    <nav className={`nav${scrolled ? " nav-scrolled" : ""}`}>
      <div className="nav-logo">
        <Link to="/">
          <img src={Logo} alt="Sendcheap Logo" className="logo" />
        </Link>
      </div>

      <ul className="nav-links-list">
        <li className="nav-links">
          <a href="#services" onClick={handleFeaturesClick}>Features</a>
        </li>
        <li className="nav-links">
          <Link to="/apis">APIs</Link>
        </li>
        <li className="nav-links">
          <Link to="/contact">Contact</Link>
        </li>
      </ul>

      <div className="nav-button">
        <a href="https://onelink.to/n9hyxn" target="_blank" rel="noreferrer">
          <button className="btn">Open Account</button>
        </a>
      </div>

      {/* Hamburger / Close — inline SVG */}
      <button
        className="nav-hamburger"
        onClick={() => setClicked(!clicked)}
        aria-label={clicked ? "Close menu" : "Open menu"}
      >
        {clicked ? (
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
            <line x1="3" y1="3" x2="19" y2="19" stroke="white" strokeWidth="2.2" strokeLinecap="round"/>
            <line x1="19" y1="3" x2="3" y2="19" stroke="white" strokeWidth="2.2" strokeLinecap="round"/>
          </svg>
        ) : (
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
            <line x1="3" y1="6" x2="19" y2="6" stroke="white" strokeWidth="2.2" strokeLinecap="round"/>
            <line x1="3" y1="11" x2="19" y2="11" stroke="white" strokeWidth="2.2" strokeLinecap="round"/>
            <line x1="3" y1="16" x2="14" y2="16" stroke="white" strokeWidth="2.2" strokeLinecap="round"/>
          </svg>
        )}
      </button>
    </nav>
  );
};

export default Navbar;
